
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 104">
<path d="M13 78V30.5955L49.699 67.2978C50.0011 67.6 50.3598 67.8398 50.7546 68.0034C51.1495 68.167 51.5726 68.2512 52 68.2512C52.4274 68.2512 52.8505 68.167 53.2454 68.0034C53.6402 67.8398 53.9989 67.6 54.301 67.2978L91 30.5955V78H13ZM52 60.4045L17.5955 26H86.4045L52 60.4045ZM6.5 84.5H97.5V19.5H6.5V84.5Z" fill="currentColor"/>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'EmailLine',
    }) as DefineComponent
    </script>
    